export default __webpack_public_path__ + "static/media/login.7a5bd4a3.jpeg";